import AssignmentsExperiments from 'bundles/epic/clients/Assignments';
import localCourseId from 'bundles/phoenix/courseId';
import { createFeatureScope } from 'bundles/product-features';

type CourseExclusionsRolloutConfigType = {
  alwaysExcludeCourses: Array<string>;
  alwaysExcludePartnerIds: Array<string>;
};

type IsFeatureEnabledForCourseFunction = (courseId?: string) => boolean;

export const isPreventAddingNewQuizzesEnabled: IsFeatureEnabledForCourseFunction = (courseId = undefined) => {
  const rolloutConfig: CourseExclusionsRolloutConfigType = AssignmentsExperiments.get(
    'preventAddingNewQuizzesRolloutConfig'
  );
  const { alwaysExcludeCourses = [] } = rolloutConfig || {};
  const currentCourseId = courseId ?? localCourseId;

  // We might make exceptions for certain courses.  This could be a different course list than the Unify-excluded courses.
  if (alwaysExcludeCourses.includes(currentCourseId)) {
    return false;
  }

  return AssignmentsExperiments.get('enablePreventAddingNewQuizzes');
};

export const isReviewSubmissionScreenEnabledForAutoGradedQuestions = () => {
  return AssignmentsExperiments.get('enableReviewSubmissionScreenForAutoGradedQuestions');
};

export const isRetryAssignmentFromFeedbackPageEnabled = () => {
  return AssignmentsExperiments.get('enableRetryAsmntFromFeedbackPage');
};

export const isAssignmentCoachMVPEnabled = () => {
  return AssignmentsExperiments.get('enableAssignmentCoachMVP');
};

export const isNextGenAssignmentsQuestionByQuestionEnabled = ({
  courseId = undefined,
  partnerId = undefined,
}: {
  courseId?: string;
  partnerId?: string;
}) => {
  const rolloutConfig: CourseExclusionsRolloutConfigType = AssignmentsExperiments.preview(
    'nextGenAssignmentsQuestionByQuestionRolloutConfig'
  );

  const { alwaysExcludeCourses = [], alwaysExcludePartnerIds = [] } = rolloutConfig || {};
  const currentCourseId = courseId ?? localCourseId;

  if (currentCourseId && alwaysExcludeCourses.includes(currentCourseId)) {
    return false;
  }

  if (partnerId && alwaysExcludePartnerIds.includes(partnerId)) {
    return false;
  }

  return AssignmentsExperiments.get('enableNextGenAssignmentsQuestionByQuestion_90-10');
};

// TODO: delete function after AA data collection is complete
export const isNextGenAssignmentsQuestionByQuestionExclusionAATestEnabled = ({
  courseId = undefined,
  partnerId = undefined,
}: {
  courseId?: string;
  partnerId?: string;
}) => {
  const rolloutConfig: CourseExclusionsRolloutConfigType = AssignmentsExperiments.preview(
    'nextGenAssignmentsQuestionByQuestionRolloutConfig'
  );

  const { alwaysExcludeCourses = [], alwaysExcludePartnerIds = [] } = rolloutConfig || {};
  const currentCourseId = courseId ?? localCourseId;

  if (currentCourseId && alwaysExcludeCourses.includes(currentCourseId)) {
    return false;
  }

  if (partnerId && alwaysExcludePartnerIds.includes(partnerId)) {
    return false;
  }

  return AssignmentsExperiments.get('enableNextGenAssignmentsPhase1AAExclusionTest');
};

export const isGeneratedCodingPracticeTest1Enabled = (courseId: string, itemId: string) => {
  return (
    AssignmentsExperiments.get('enableGeneratedCodingPracticeTest1') &&
    AssignmentsExperiments.get('generatedCodingPracticeTest1Config').itemIncludeList[courseId]?.includes(itemId)
  );
};

export const isMasteryLevelsEnabled = () => {
  return AssignmentsExperiments.get('enableMasteryLevels');
};

// Product feature toggle to opt out orgs https://www.coursera.org/internal/feature-toggles?name=enableAssignmentCoachMVP&namespace=enterprise
export const { ProductFeaturesQuery, useProductFeatures } = createFeatureScope({
  enterprise: {
    enableAssignmentCoachMVP: true,
  },
});
